<template>
  <div id="changePassword">
    <div class="passwordFirst">
      <div class="passwordFirstTitle">密码修改</div>
   
    </div>
    <div class="changePasswordForm">
      <Form
        ref="formCustom"
        :model="formCustom"
        :rules="ruleCustom"
        :label-width="80"
      >
        <FormItem label="旧密码" prop="oldPassword">
          <Input  type="password" password v-model="formCustom.oldPassword"></Input>
        </FormItem>
        <FormItem label="新密码" prop="newPassword">
          <Input  type="password" placeholder="请输入密码" password v-model="formCustom.newPassword"></Input>
        </FormItem>
        <FormItem label="确认密码" prop="newPassword1">
          <Input  type="password" placeholder="请确认密码" password v-model="formCustom.newPassword1"></Input>
        </FormItem>

        <FormItem>
          <Button type="primary"  @click="handleSubmit()">提交修改</Button>
        </FormItem>
      </Form>
    </div>
    
  </div>
</template>

<script>
import { postPsw } from "../../../network/LPersonal";
import { logout } from "network/home.js";
import md5 from "js-md5";
import Cookies from "js-cookie";
export default {
  data() {
    const password = (rule, value, callback) => {
        if(!(/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$/.test(value))){ 
            callback(new Error('密码必须由数字、字母和特殊字符（如!、#、$、%等）组成,请输入8-20位'));
        } 
        else {
          callback();
        }
    };
    return {
      formCustom: {
        newPassword: "",
        newPassword1: "",
        oldPassword: "",
        
      },
      ruleCustom: {
        newPassword: [
          { required: true, validator: password, trigger: "blur" },
        ],
        newPassword1: [
          { required: true, validator: password, trigger: "blur" },
        ],
        oldPassword: [
          { required: true, trigger: "blur" ,message:"请输入旧密码"},
        ],
      },
      password: "",
    };
  },
  created() {
    this.password = this.Get("password");
    console.log(this.password);
    this.$emit("editPage", "密码修改", "密码修改");
  },
  activated(){
    this.$emit("editPage", "密码修改", "密码修改");
  },
  methods: {
     logout() {
      logout().then(r=>{
        console.log(r);
      })
     },
    Get(name) {
      return Cookies.get(`admin-${name}`);
    },
    handleSubmit() {
      // this.$Message.success('Success!');
      this.password = this.Get("password");
    //   console.log(this.password);
      if (this.formCustom.oldPassword && this.formCustom.newPassword && this.formCustom.newPassword1) {
        if( this.formCustom.oldPassword==this.formCustom.newPassword){
              this.$Message.error("新旧密码不能相同!");
        }else{
          if(this.formCustom.newPassword == this.formCustom.newPassword1){
            let form = {
            id: this.Get("userId"),
            newPassword: md5(this.formCustom.newPassword),
            oldPassword: md5(this.formCustom.oldPassword),
           };
          postPsw(form).then((res) => {
                   console.log(res);
              if(res.data.code==200){
                    this.$Message.success(res.data.msg);
                    this.logout();
                    this.$router.push("/login");
              } else{
                this.$Message.error(res.data.msg)
              }
          });
          } else{
            this.$Message.error("两次密码不一致")
          }
      }} else {
        this.$Message.error("必填不能为空!");
      }
    },
  },
};
</script>

<style>
@import url("../../../assets/css/liucss/changePassword.css");
</style>